import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const equalTo = (equalControl: AbstractControl): ValidatorFn => {
  const key = 'equalTo';
  let subscribe = false;

  return (control: AbstractControl): ValidationErrors | null => {
    if (!subscribe) {
      subscribe = true;
      equalControl.valueChanges.subscribe(() => {
        control.updateValueAndValidity();
      });
    }

    const value = control.value;

    if (!value) return null;

    if (equalControl.value !== value) return { [key]: true };

    return null;
  };
};
